<div class="parallax" *ngIf="!loadBestSales && bestSalesProduct.length>0">
    <div class="title">
        <h1>
            <strong>Top Des Ventes </strong>
        </h1>
    </div>
    <div class="container">
        <div *ngIf="loadBestSales" id="loadingPage"></div>
        <div class="bestSales" *ngIf="!loadBestSales">
            <div class="prod" *ngFor="let product of bestSalesProduct;let i=index">
                <product (OnPersonalize)="PersonalizeModal(i)" (OnAdd)="addElementToBasket(i)" [product]="product" [id]="'bestSales-'+product.id"></product>
            </div>
        </div>
    </div>
</div>